<template>
   <div class="confirm-pick-up">
       <ConfirmationDialog v-model="visible"
                           :id="id"
                           :persistent="true"
                           title="Confirm Loading"
                           @cancel="cancel"
                           @confirm="confirm">
           Set itinerary as loaded, are you sure?
       </ConfirmationDialog>
   </div>
</template>

<script>

import AccessType from '@/components/Core/AccessType'
import ConfirmationDialog from '@/components/Core/Dialog/Confirmation'

export default {
  extends: AccessType,
  components: {
    ConfirmationDialog
  },
  name: 'ConfirmPickUp',
  props: {
    carItineraryHelper: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'show',
    event: 'visibility'
  },
  data () {
    return {
      showChangeForbiddenDialog: false,
      showErrorDialog: false,
      showSignatureErrorDialog: false,
      visible: false,
      id: 'confirm-pick-up-' + this.carItineraryHelper.getCarItinerary().id
    }
  },
  methods: {
    hide () {
      this.visible = false
    },
    confirm () {
      if (this.isPrivate()) {
        this.$router.push({ name: 'CmrLiabilities', params: { carItineraryId: this.carItineraryHelper.getCarItinerary().id } })
      } else if (this.isPublic()) {
        this.$router.push({ name: 'EncryptedCmrLiabilities', params: { carItineraryId: this.carItineraryHelper.getCarItinerary().id, encryptedData: this.encryptedData } })
      }
    },
    cancel () {
      this.$emit('cancel')
      this.hide()
    }
  },
  watch: {
    show: function (newVal) {
      if (newVal) {
        this.visible = newVal
        this.$emit('visibility')
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
